import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot } from '@angular/router';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class NotAuhorizedGuardService implements CanActivate {

  constructor(private authService: AuthService, private router: Router) { }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    return this.checkLogin(route);
  }

  private checkLogin(route: ActivatedRouteSnapshot): boolean {
    if (!this.authService.isLoggedIn() && !this.authService.waitingConfirmation()) { return true; }

    this.router.navigate([''], { queryParams: route.queryParams });
  }
}

